<template>
  <div class="mapbox">
    <div class="closebtn" @click="$emit('goBack')">关闭 ×</div>
    <!-- <img :src="currentImage" class="detail-img" /> -->
    <div class="imgbox">
      <img v-for="(img, i) in images" :key="i" :src="img" class="image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FarmerDetail',

  //接收图片index参数
  props: {
    farmerImageIndex: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      images: [
        // require('../assets/images/farmer_products/product1.png'),
        require('../assets/images/farmer_products/stuff1.jpg'),
        require('../assets/images/farmer_products/stuff2.png'),
        require('../assets/images/farmer_products/product2.png'),
        require('../assets/images/farmer_products/product3.png')
      ]
    }
  },

  computed: {
    currentImage() {
      return this.images[this.farmerImageIndex]
    }
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  height: 100%;
  padding: 16px;
  gap: 12px;
  flex-direction: column;
}

.closebtn {
  color: #83ffe1;
  text-align: right;
  margin: 20px 15px;
  cursor: pointer;
}

.detail-img {
  width: 100%;
  height: 80%;
  object-fit: fill;
  border-radius: 8px;
  padding: 15px 20px;
}

.imgbox {
  display: flex;
  align-items: center;
  height: 80%;
  flex-wrap: wrap;
  /* padding: 0 15px; */
  /* gap: 10px; */
  justify-content: center;
}

.image {
  height: 220px;
  width: 35%;
  margin: 0 20px;
}
</style>
